import { render, staticRenderFns } from "./NewsStories.vue?vue&type=template&id=0c461b8e&"
import script from "./NewsStories.vue?vue&type=script&lang=js&"
export * from "./NewsStories.vue?vue&type=script&lang=js&"
import style0 from "./NewsStories.vue?vue&type=style&index=0&id=0c461b8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports